module.exports = __webpack_public_path__ + "static/media/flag-po.b42e6133.webp";